export default "__VITE_ASSET__BJS0SuDm__"